import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { updateCurrentOrganization } from '@/api/services/organization.service'
import { getErrorMessage } from '@/lib/getErrorMessage'
import { organizationQueryKeys } from './useCurrentOrganization'
import type { UpdateOrganizationPayload } from '@/types/organization.types'

export function useUpdateOrganization() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: UpdateOrganizationPayload) =>
      updateCurrentOrganization(payload),
    onSuccess: (organization) => {
      queryClient.setQueryData(organizationQueryKeys.current, organization)
      queryClient.invalidateQueries({ queryKey: organizationQueryKeys.current })
      toast.success('Organization updated')
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    },
  })
}
